"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useProgramPageActionsApi = require("./useProgramPageActionsApi");
Object.keys(_useProgramPageActionsApi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useProgramPageActionsApi[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useProgramPageActionsApi[key];
    }
  });
});
var _useCommonPageActionsApi = require("./useCommonPageActionsApi");
Object.keys(_useCommonPageActionsApi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useCommonPageActionsApi[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useCommonPageActionsApi[key];
    }
  });
});
var _useNetworkhealthPageActionsApi = require("./useNetworkhealthPageActionsApi");
Object.keys(_useNetworkhealthPageActionsApi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useNetworkhealthPageActionsApi[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useNetworkhealthPageActionsApi[key];
    }
  });
});
var _useBackgroundFilterPageActionsApi = require("./useBackgroundFilterPageActionsApi");
Object.keys(_useBackgroundFilterPageActionsApi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useBackgroundFilterPageActionsApi[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useBackgroundFilterPageActionsApi[key];
    }
  });
});